html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
}

#root {
  min-height: 100dvh;
}
